import { render, staticRenderFns } from "./Dharmas.vue?vue&type=template&id=60cac0bb&"
import script from "./Dharmas.vue?vue&type=script&lang=js&"
export * from "./Dharmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports